// extracted by mini-css-extract-plugin
export default {"container":"gn-z","bubbleNav":"hn-z","graphic":"in-z","contact":"jn-z"};